import React from "react";
import PageHeader from "../components/PageHeader";
import { commonImg } from "../assets/assets.js";
import "../css/commontemplate.css";

export const Education = () => {
  return (
    <>
      <PageHeader
        title="अंतर्गत विविध उपक्रम "
        path="/about-goshala"
        name=" goshala"
      />
      <div className="comman-template-section">
        <div className="comman-template-container">
          {/* container  */}
          <div className="comman-template-sub-section">
            <div className="comman-template-img-container">
              <img
                className="comman-template-image"
                src={commonImg.com_upkarm}
                alt=""
              />
            </div>

            <div className="comman-template-info-container">
              {/* info container */}
              <h3>उपक्रम</h3>

              <p>
                <ul>
                  <li>
                    ग्रामस्थांच्या व विद्यार्थ्यांच्या सहभागातून पर्यावरण
                    संतुलनाच्या हेतूने वृक्षारोपण व ग्रामस्वच्छता.{" "}
                  </li>
                  <li>
                    {" "}
                    गुरुकुलाच्या माध्यमातून गावातील समस्त जाती वर्गांतील
                    आबालवृद्धांसाठी गीता, मनाचे श्लोक, हरिपाठ, स्तोत्र पाठासह
                    सांस्कृतिक-पौराणिक कथा इ.संस्कार वर्गाच्या माध्यमातून
                    शिकवण्याचा उपक्रम{" "}
                  </li>
                  <li>
                    {" "}
                    समाजातील सांस्कृतिक विचारधारा विकसित करून संघटन साधण्याच्या
                    हेतूने व सांस्कृतिक कार्यक्रमांचे वेळोवेळी विशेष आयोजन
                  </li>
                  <li>
                    {" "}
                    विद्यार्थ्यांच्या ज्ञानोपासनेबरोबरंच योगसाधना, सूर्यनमस्कार, योगासने, व्यायाम इ. च्या माध्यमातून आध्यात्मिक उपासना व
                    बलोपासनेकडे विशेष लक्ष{" "}
                  </li>
                  <li>
                    {" "}
                    आरोग्यशिबिर, रक्तदानशिबिरांचे सांस्कृतिक कार्यक्रमाच्या
                    निमित्ताने आयोजन श्रमदानातून ग्रामस्वच्छता
                  </li>
                  <li>
                    {" "}
                    गुरुकुलाच्या माध्यमातून गावातील समस्त जाती वर्गांतील
                    आबालवृद्धांसाठी गीता, मनाचे श्लोक, हरिपाठ, स्तोत्र पाठासह
                    सांस्कृतिक-पौराणिक कथा इ. संस्कार वर्गाच्या माध्यमातून
                    शिकवण्याचा उपक्रम{" "}
                  </li>
                  <li>
                    {" "}
                    विद्यार्थ्यांच्या प्रगतीसाठी वेळोवेळी कथाकथन, पाठांतर इ.
                    विविध स्पर्धाचे आयोजन
                  </li>
                  <li> सांस्कृतिक कार्यक्रमांचे भव्य स्वरूपात आयोजन</li>
                  <li>
                    {" "}
                    सांस्कृतिक कार्यक्रमांच्या निमित्ताने आबालवृद्धांना अन्नदान
                  </li>
                </ul>
              </p>
            </div>
          </div>

          <div className="comman-template-sub-section"></div>
        </div>
      </div>

    </>
  );
};
